import { render } from "./SimpleToastMessage.vue?vue&type=template&id=5fc2f8e5"
const script = {}

import "./SimpleToastMessage.vue?vue&type=style&index=0&id=5fc2f8e5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__